import { useContext, useState, useEffect } from 'react';
import {
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material';

import {
  DriveFileRenameOutline as DriveFileRenameOutlineIcon,
} from '@mui/icons-material';

import { AuthContext, stopPropagationForTab } from 'components';


export const EditCollection = (props) => {
  const { title, collection, onClose } = props;
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(title);
  const { renameCollection } = useContext(AuthContext);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    if (onClose) { onClose() };
  }

  const handleSave = () => {
    renameCollection(collection, value, () => {
      handleClose()
    })
  }
  
  return (
    <>
      <IconButton onClick={handleOpen}>
        <DriveFileRenameOutlineIcon />
      </IconButton>
      <Dialog onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Rename Collection</DialogTitle>
        <DialogContent>
          <DialogContentText>
          </DialogContentText>
          <TextField
            autoFocus
            value={value}
            onChange={(event) => { setValue(event.target.value) }}
            onKeyDown={e => { if(e.key === 'Enter') { handleSave() } }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}